import React, { useEffect, useState } from 'react';
import './SecretKeyPage.css';
import mfaimage from "../../assets/images/mfa/mfa-image.svg";
import closedEyeIcon from "../../assets/images/mfa/close-eye-icon.svg";
import openEyeIccon from "../../assets/images/mfa/open-eye-icon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import arrorIcon from "../../assets/images/mfa/ic-arrow-back.svg";
import MFASuccessModal from './MFASuccessModal';
import MFAFailureModal from "./MFAFailureModal";
import { getConfig } from "../../config";
import APIManager from '../../Services/ApiManager/ApiManager';

const SecretKeyPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { qrData } = location.state || {};
    const [showSecret, setShowSecret] = useState(false);
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showFailureModal, setShowFailureModal] = useState(false);


    useEffect(() => {
        if (qrData?.secretCode) {
            try {
                const urlParams = new URLSearchParams(qrData.secretCode.split('?')[1]);
                urlParams.get('secret');
            } catch (error) {
                console.error("Error extracting secret:", error);
            }
        }
    }, [qrData]);

    const handleValidateSecretKey = async () => {

        if (otp?.length !== 6) {
            return;
        }
        setLoading(true);
        const data = {
            otp: otp.toString(),
        };
        APIManager.patchVerifySoftwareToken(data)
            .then((json) => {
                setShowSuccessModal(true);
                setOtp("");
            })
            .catch((error) => {
                setShowFailureModal(true);
            });

    };

    const handleLogin = async () => {
        // Call revoke and logout API here
        const app_portal = getConfig().REACT_APP_PORTAL;
        let clientId;
        let scopeId;

        if (app_portal === "oem-admin") {
            clientId = getConfig().REACT_APP_OEM_ADMIN_CLIENT_ID;
        } else if (app_portal === "seller") {
            clientId = getConfig().REACT_APP_CLIENT_ID;
        } else if (app_portal === "domain-approver") {
            clientId = getConfig().REACT_APP_DOMAIN_APPROVER_CLIENT_ID;
        } else if (app_portal === "global-admin") {
            clientId = getConfig().REACT_APP_GLOBAL_ADMIN_CLIENT_ID;
        } else {
            clientId = "";
        }

        if (app_portal === "oem-admin") {
            scopeId = "rs%2FigniteStorePortfolioManager%20openid%20aws.cognito.signin.user.admin";
        } else if (app_portal === "domain-approver") {
            scopeId = "rs%2FigniteStoreDomainApprover%20openid%20aws.cognito.signin.user.admin";
        } else if (app_portal === "global-admin") {
            scopeId = "rs%2FigniteStoreAdmin%20openid%20aws.cognito.signin.user.admin";
        } else if (app_portal === "seller") {
            scopeId = "rs%2FigniteStoreSeller%20openid%20aws.cognito.signin.user.admin";
        } else {
            scopeId = "";
        }

        const revokeURL = `${getConfig().REACT_APP_COGNITO_DOMAIN}/oauth2/revoke`;
        const refreshToken = sessionStorage.getItem("refresh_token");

        if (refreshToken && clientId) {
            try {
                const body = new URLSearchParams();
                body.set("token", refreshToken);
                body.set("client_id", clientId);

                await fetch(revokeURL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: body.toString(),
                });
            } catch (error) {
                console.error("Error revoking token:", error);
            }
        }

        // Call logout API and redirect to login
        const cognitoDomain = getConfig().REACT_APP_COGNITO_DOMAIN;
        const redirect_uri = getConfig().REACT_APP_REDIRECT_URI;
        const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&response_type=code&scope=${scopeId}&redirect_uri=${redirect_uri}&portal=${app_portal}`;

        sessionStorage.clear();
        globalThis.location.href = logoutUrl;
    };

    const handleStartOver = () => {
        setShowFailureModal(false);
        navigate(-1);
    };

    const handleTryAgain = () => {
        setShowFailureModal(false);
        setOtp("");
    };

    const toggleSecretVisibility = () => {
        setShowSecret(!showSecret);
    };

    const handleInputChange = (e) => {
        const value = e.target.value.replaceAll(/\D/g, '');
        if (value.length <= 6) {
            setOtp(value);
        }
    };

    const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading && otp.length === 6) {
        handleValidateSecretKey();
    }
};

    return (
        <div className="secret-key-page">
            <button className="back-link" onClick={() => navigate(-1)}>
                <img src={arrorIcon} alt="Back Arrow" className="back-icon" />
                <span className="back-text">Back</span>
            </button>
            <div className="secret-key-container">
                <div className="logo-section">
                    <img src={mfaimage} alt="ready-link-marketplace" className="logo" />
                </div>
                <h6 className="secret-key-text">Your Secret KEY is</h6>
                <div className="secret-input-header">
                    <div className="secret-input-wrapper">
                        <input
                            type={showSecret ? "text" : "password"}
                            value={otp}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            maxLength={6}
                            className="secret-input"
                        />
                        <button
                            className="eye-icon"
                            onClick={toggleSecretVisibility}
                            type="button"
                            aria-label={showSecret ? "Hide secret key" : "Show secret key"}
                        >
                            <img
                                src={showSecret ? openEyeIccon : closedEyeIcon}
                                alt="toggle visibility"
                                className="eye-image"
                            />
                        </button>
                    </div>
                    <div className="heading-section">
                        <span className="secret-key-heading">
                            Use this key to configure the secret key in any of your authenticator apps like Google authenticator, Authy or any other..
                        </span>
                    </div>
                </div>


                <button
                    className="generate-btn"
                    onClick={handleValidateSecretKey}
                    disabled={loading || otp.length !== 6}
                    style={{ marginTop: '20px', pointerEvents: loading ? 'none' : 'auto' }}
                >
                    Next
                </button>
                {}
            </div>
            <div className="footer-container">
                <p className="footer-text">
                    Copyright © 2020 HARMAN International. All Rights Reserved.
                </p>

                <p className="footer-text">
                    Need help? Please contact us at{" "}
                    <a href="mailto:IgniteDevSupport@Harman.com" className="footer-link">
                        IgniteDevSupport@Harman.com
                    </a>
                </p>
                <p href="/developer-agreementDeveloper Agreement">Developer Agreement
                </p>
            </div>

            <MFASuccessModal
                isOpen={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                onLogin={handleLogin}
            />

            <MFAFailureModal
                isOpen={showFailureModal}
                onClose={() => setShowFailureModal(false)}
                onStartOver={handleStartOver}
                onTryAgain={handleTryAgain}
            />
        </div>
    )
}

export default SecretKeyPage;